import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ReactivateAssetWizardEffectsV26 } from './effects';
import * as fromReactivateAssetWizardV26 from './reducer';

export function provideReactivateAssetWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromReactivateAssetWizardV26.reactivateAssetWizardFeatureKey, fromReactivateAssetWizardV26.reducer),
    provideEffects(ReactivateAssetWizardEffectsV26),
  ]);
}
